import { ReactNode } from 'react'

export function Title({ children }: { children: ReactNode }) {
  return (
    <dt className="text-base font-normal text-gray-500">
      {children}
    </dt>
  )
}